webpackJsonp([4523052877259],{

/***/ 170:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _remark = __webpack_require__(26);
	
	var _remark2 = _interopRequireDefault(_remark);
	
	var _remarkPresetLintRecommended = __webpack_require__(25);
	
	var _remarkPresetLintRecommended2 = _interopRequireDefault(_remarkPresetLintRecommended);
	
	var _remarkHtml = __webpack_require__(24);
	
	var _remarkHtml2 = _interopRequireDefault(_remarkHtml);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Offerings = function Offerings(_ref) {
	    var gridItems = _ref.gridItems;
	    return _react2.default.createElement(
	        'div',
	        { className: 'columns is-multiline' },
	        gridItems.map(function (item) {
	            return _react2.default.createElement(
	                'div',
	                { key: item.image, className: 'column is-6' },
	                _react2.default.createElement('div', { dangerouslySetInnerHTML: { __html: (0, _remark2.default)().use(_remarkPresetLintRecommended2.default).use(_remarkHtml2.default).processSync(item.text).toString() } })
	            );
	        })
	    );
	}; /**
	    * Created by vaibhav on 1/4/18
	    */
	
	
	Offerings.propTypes = {
	    gridItems: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        image: _propTypes2.default.string,
	        text: _propTypes2.default.string
	    }))
	};
	
	exports.default = Offerings;
	module.exports = exports['default'];

/***/ }),

/***/ 405:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = exports.PageTemplate = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(35);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Offerings = __webpack_require__(170);
	
	var _Offerings2 = _interopRequireDefault(_Offerings);
	
	var _Testimonials = __webpack_require__(120);
	
	var _Testimonials2 = _interopRequireDefault(_Testimonials);
	
	var _OpenTime = __webpack_require__(119);
	
	var _OpenTime2 = _interopRequireDefault(_OpenTime);
	
	var _Fade = __webpack_require__(30);
	
	var _Fade2 = _interopRequireDefault(_Fade);
	
	var _ImagesCarousel = __webpack_require__(82);
	
	var _ImagesCarousel2 = _interopRequireDefault(_ImagesCarousel);
	
	var _reactFlexboxGrid = __webpack_require__(41);
	
	var _gatsbyImage = __webpack_require__(21);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _UbHome = __webpack_require__(122);
	
	var _UbHome2 = _interopRequireDefault(_UbHome);
	
	var _Ub = __webpack_require__(121);
	
	var _Ub2 = _interopRequireDefault(_Ub);
	
	var _SvgEl = __webpack_require__(44);
	
	var _SvgEl2 = _interopRequireDefault(_SvgEl);
	
	var _remark = __webpack_require__(26);
	
	var _remark2 = _interopRequireDefault(_remark);
	
	var _remarkPresetLintRecommended = __webpack_require__(25);
	
	var _remarkPresetLintRecommended2 = _interopRequireDefault(_remarkPresetLintRecommended);
	
	var _remarkHtml = __webpack_require__(24);
	
	var _remarkHtml2 = _interopRequireDefault(_remarkHtml);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by vaibhav on 31/3/18
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var bowser = __webpack_require__(47);
	
	var PageTemplate = exports.PageTemplate = function PageTemplate(_ref) {
	  var title = _ref.title,
	      templateKey = _ref.templateKey,
	      heading = _ref.heading,
	      description = _ref.description,
	      meta_title = _ref.meta_title,
	      meta_description = _ref.meta_description,
	      language = _ref.language,
	      closingDay = _ref.closingDay,
	      dayOn = _ref.dayOn,
	      dayOff = _ref.dayOff,
	      grid = _ref.grid,
	      page_heading = _ref.page_heading,
	      text = _ref.text,
	      text1 = _ref.text1,
	      browserDataName = _ref.browserDataName,
	      browserSafari = _ref.browserSafari,
	      osDataName = _ref.osDataName;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      _reactHelmet2.default,
	      {
	        bodyAttributes: {
	          class: templateKey + ' dct-' + browserDataName + ' dct-' + osDataName + browserSafari
	        }
	      },
	      _react2.default.createElement('html', { lang: language }),
	      _react2.default.createElement(
	        'title',
	        null,
	        meta_title
	      ),
	      _react2.default.createElement('meta', { name: 'description', content: meta_description })
	    ),
	    _react2.default.createElement(
	      _Fade2.default,
	      null,
	      _react2.default.createElement(
	        'section',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'columns' },
	          _react2.default.createElement(
	            'div',
	            { className: 'column is-10 is-offset-1 has-margin-top-2' },
	            _react2.default.createElement(
	              'h1',
	              { className: 'title title-section is-size-1 has-text-centered sand-dark' },
	              page_heading
	            ),
	            _react2.default.createElement(
	              'h2',
	              { className: 'title-sub is-size-3 has-text-centered' },
	              heading
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'section',
	        { className: 'section section--gradient bg-sand' },
	        _react2.default.createElement(
	          'div',
	          { className: 'container' },
	          _react2.default.createElement(
	            'div',
	            { className: 'columns' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-4 is-offset-2' },
	              _react2.default.createElement(
	                'p',
	                null,
	                'Do not hesitate and contact R\xE9mi Blot for any inquiry. He will attend you in english, german, spanish or french'
	              )
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'column is-6' },
	              _react2.default.createElement('div', { className: 'Ub-address', dangerouslySetInnerHTML: { __html: (0, _remark2.default)().use(_remarkPresetLintRecommended2.default).use(_remarkHtml2.default).processSync(text).toString() } })
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	PageTemplate.propTypes = {
	  title: _propTypes2.default.string,
	  closingDay: _propTypes2.default.number,
	  dayOn: _propTypes2.default.string,
	  dayOff: _propTypes2.default.string,
	  meta_title: _propTypes2.default.string,
	  meta_description: _propTypes2.default.string,
	  heading: _propTypes2.default.string,
	  description: _propTypes2.default.string,
	  text: _propTypes2.default.string,
	  text1: _propTypes2.default.string,
	  grid: _propTypes2.default.object,
	  page_heading: _propTypes2.default.string
	
	};
	
	var Page = function (_React$Component) {
	  _inherits(Page, _React$Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      browserData: '',
	      osData: ''
	    };
	    return _this;
	  }
	
	  Page.prototype.componentDidMount = function componentDidMount() {
	    var browser = bowser.getParser(window.navigator.userAgent);
	    var browserData = browser.parsedResult.browser;
	    var osData = browser.parsedResult.os;
	    this.setState({
	      browserData: browserData,
	      osData: osData
	    });
	  };
	
	  Page.prototype.render = function render() {
	    var frontmatter = this.props.data.markdownRemark.frontmatter;
	    var siteMetadata = this.props.data.site.siteMetadata;
	
	
	    return _react2.default.createElement(PageTemplate, {
	      title: frontmatter.title,
	      meta_title: frontmatter.meta_title,
	      templateKey: frontmatter.templateKey,
	      browserDataName: this.state.browserData.name,
	      osDataName: this.state.osData.name,
	      browserSafari: this.state.browserData.name !== 'Safari' ? ' dct-not-Safari' : '',
	      meta_description: frontmatter.meta_description,
	      heading: frontmatter.heading,
	      description: frontmatter.description,
	      offerings: frontmatter.offerings,
	      language: frontmatter.language,
	      closingDay: siteMetadata.closingDay,
	      dayOn: siteMetadata.dayOn,
	      dayOff: siteMetadata.dayOff,
	      text: frontmatter.text,
	      text1: frontmatter.text1,
	      grid: this.props.data,
	      page_heading: frontmatter.page_heading
	    });
	  };
	
	  return Page;
	}(_react2.default.Component);
	
	Page.propTypes = {
	  data: _propTypes2.default.shape({
	    markdownRemark: _propTypes2.default.shape({
	      frontmatter: _propTypes2.default.object,
	      siteMetadata: _propTypes2.default.object
	    })
	  })
	};
	
	exports.default = Page;
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-page-kontakt-js-b78d0852a29802a31c22.js